<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100 translate-y-0 sm:scale-100"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <ontick-modal :open="active" size="small" v-on:close="$emit('close')" class="overflow-y-auto">
      <form v-show="!success" class="space-y-6 pb-6" autocomplete="off" method="post" action="">
        <input autocomplete="false" name="hidden" type="text" style="display: none" />
        <div class="space-y-1">
          <h1 class="text-center text-2xl font-medium">Alterar minha senha</h1>
          <p class="text-center text-xs text-gray-500 dark:text-gray-400">
            Código será enviado para o email cadastrado
          </p>
        </div>

        <!-- <pin-code-input
          v-model="code"
          :secure="false"
          :characterPreview="false"
          :length="6"
          v-validate="'required'"
          name="code"
          :error="errors.first('code')"
        /> -->

        <ontick-pin-code-input-component v-model="code" :autofocus="true" :codelength="6" />

        <password-validate-component
          ref="new_password"
          name="new_password"
          label="Nova senha"
          v-model="new_password"
          v-validate="'required'"
          :error="errors.first('new_password')"
          autocomplete="new-password"
        />

        <password-validate-component
          data-vv-as="new_password"
          name="confirm_password"
          label="Confirmar senha"
          v-model="confirm_password"
          v-validate="'required|confirmed:new_password'"
          :error="errors.first('confirm_password')"
          bg="bg-ontick-steel-500"
          autocomplete="confirm-password"
        />

        <ontick-button @click.native="changePassword()" class="w-full uppercase">
          <span v-if="!loading">Alterar</span>
          <span v-if="loading" v-html="$icons.loading"></span>
        </ontick-button>
      </form>
      <div v-show="success" class="flex justify-center text-center">
        <dt class="py-12">
          <span v-html="$icons.success"></span>
          <h1 class="py-6 text-2xl font-semibold uppercase text-gray-300">Senha alterada com sucesso.</h1>
        </dt>
      </div>
    </ontick-modal>
  </transition>
</template>

<script>
import { Auth } from "aws-amplify";

import PinCodeInput from "vue-pincode-input";
import passwordValidateComponent from "../../../auth/components/password.validate.component.vue";
import OntickPinCodeInputComponent from "../../../../shared/components/basic/ontick-pin-code-input.component.vue";
export default {
  components: {
    passwordValidateComponent,
    PinCodeInput,
    OntickPinCodeInputComponent,
  },

  props: {
    active: false,
  },

  data() {
    return {
      loading: false,
      success: false,
      code: "",
      confirm_password: "",
      new_password: "",
    };
  },

  methods: {
    changePassword() {
      this.$validator.validate().then((valid) => {
        let params = {
          email_code: this.code,
          new_password: this.new_password,
          new_password_repeat: this.confirm_password,
        };
        this.loading = true;
        if (valid) {
          this.$api
            .post(this.$endpoint.PASSSWORD_CONFIRM, params)
            .then(() => {
              this.success = true;
              setTimeout(() => {
                try {
                  Auth.signOut();
                  this.$router.push({ path: "/auth" });
                } catch (error) {
                  alert(error.message);
                }
              }, 5000);
            })
            .catch((error) => {
              this.$swal({
                title: error.message,
                icon: "error",
                timer: 5000,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
div.vue-pincode-input-wrapper {
  @apply flex justify-center space-x-3;
}

input.vue-pincode-input {
  @apply border-ontick-carbon-500 bg-ontick-carbon-500 border-2 text-xl font-medium text-gray-300 shadow-lg #{!important};
  max-width: 43px;
  max-height: 43px;
  margin: 0px;
  transition: all 0.3s ease;

  &:focus {
    border: 2px solid #07a4ff;
  }
}
</style>
